<template>
    <div class="card" style="min-height: 450px;">
        <h6 class="card-header text-primary" > Assign Menu</h6>

        <section v-if="showList">
            <AdminList 
            :rows="adminList"
            @assignadmin="assignAdmin"
            />
        </section>

        <section v-else>
            <AssignAdmin 
            :menuList="menuList"
            :adminData="adminData"
            :adminMenu="adminMenu"
            @showlist="showAdminList"
            />
        </section>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import VueBootstrap4Table from 'vue-bootstrap4-table';

import AdminList from './assignLayouts/AdminList.vue'
import AssignAdmin from './assignLayouts/AssignAdmin.vue'

export default {
    name: "AssignMenu",

    components:{
        VueBootstrap4Table,
        AdminList,
        AssignAdmin,
    },
    
    data(){
        return {
            adminData: {},
            adminMenu: [],
            adminList: [],
            menuList: [],
            showList: true,
        }
    },

    computed:{
        ...mapState(['token'])
    },

    mounted(){
        this.getSubAdminList();

        this.getMenuList();
    },

    methods:{
        assignAdmin(adminId){
            // this.adminData = this.adminList.find(admin => admin.id == adminId);
            const baseU = `${this.$urlAuth}/subadmin/${adminId}`;

            this.$http.get(baseU,{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code =='S200'){
                    this.adminData = response.data.data.subadmin;
                    this.adminMenu = response.data.data.adminMenus;

                    this.showList = false;
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(err => {
                console.log(err);
                if(err.message == 'Network Error'){
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                }else{
                    this.$toastr.e(err.message);
                }
            })
        },

        showAdminList() {
            this.showList = true;
            this.adminData = {};
            this.adminMenu = []
        },

        getSubAdminList(){
            const baseU = `${this.$urlAuth}/listsubadmins`;

            this.$http.get(baseU,{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code =='S200'){
                    this.adminList = response.data.data.subadmins

                }else{
                    this.$toastr.e(response.data.data.message);
                    this.adminList = [];
                }
            })
            .catch(err => {
                console.log(err);
                if(err.message == 'Network Error'){
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                }else{
                    this.$toastr.e('Internal server error');
                }
            })
        },

        getMenuList(){
            const baseU = `${this.$urlAuth}/menus/all`;

            this.$http.get(baseU,{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code =='S200'){
                    this.menuList = response.data.data.menus

                }else{
                    this.$toastr.e(response.data.data.message);
                    this.menuList = [];
                }
            })
            .catch(err => {
                console.log(err);
                if(err.message == 'Network Error'){
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                }else{
                    this.$toastr.e('Internal server error');
                }
            })
        }

    }
}
</script>
